



































































































import { Component, Vue } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue'
import { WorkerAnonModule } from '@/store/modules/workerAnon';
import { AppModule } from '@/store/modules/app';
import WorkerInterviewConfirmationConfirmDecline from '@/components/AnonWorkers/WorkerInterviewConfirmationConfirmDecline.vue';
import AnonJobWorkerInterviewDto from '@/models/AnonJobWorkers/AnonJobWorkerInterviewDto';
import JobWorkerInterviewType from '@/models/JobWorkerInterviews/JobWorkerInterviewType';

@Component({
  name: 'InterviewConfirmation',
  components: { WorkerInterviewConfirmationConfirmDecline }
})
export default class InterviewConfirmation extends GiganautVue {

    interviewType = JobWorkerInterviewType;

    get interviewConfirmation(): AnonJobWorkerInterviewDto {
        return WorkerAnonModule.interviewConfirmation;
    }

    get loading() {
        return WorkerAnonModule.loading;
    }

    get agency() {
        return AppModule.currentAgencyContext;
    }

    get isConfirmationSubmitted() {
        return WorkerAnonModule.isJobInterviewConfirmationSubmitted;
    }
}
